import { apiCall } from "./client";

export function getAdminOfficialMatchesStructure({
  season,
  classification = "all",
  stageType,
  hint,
  search,
} = {}) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  if (classification && classification !== "all") params.set("classification", classification);
  if (stageType && stageType !== "all") params.set("stage_type", stageType);
  if (hint && hint !== "all") params.set("hint", hint);
  if (search && search.trim()) params.set("search", search.trim());
  const qs = params.toString();
  return apiCall(`/api/admin/official-matches/structure${qs ? `?${qs}` : ""}`);
}

export function updateAdminOfficialMatchStructure(officialId, payload) {
  return apiCall(`/api/admin/official-matches/${officialId}/structure`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function bulkSetSeasonRegularSeason(season) {
  return apiCall("/api/admin/official-matches/bulk-structure", {
    method: "POST",
    body: JSON.stringify({ season }),
  });
}

export function runAdminOfficialHeatsImport() {
  return apiCall("/api/admin/import-official-heats", {
    method: "POST",
  });
}

export function runAdminOfficialMatchesImport() {
  return apiCall("/api/admin/import-official-matches", {
    method: "POST",
  });
}

export function getAdminDoubleMeetingBonus(season) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  const qs = params.toString();
  return apiCall(`/api/admin/double-meeting-bonus${qs ? `?${qs}` : ""}`);
}

export function upsertAdminDoubleMeetingBonus(payload) {
  return apiCall("/api/admin/double-meeting-bonus", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function deleteAdminDoubleMeetingBonus(season, pairKey) {
  return apiCall(`/api/admin/double-meeting-bonus/${encodeURIComponent(String(season))}/${encodeURIComponent(String(pairKey))}`, {
    method: "DELETE",
  });
}

export function getAdminPlayoffSeriesResolutions(season) {
  const params = new URLSearchParams();
  if (season != null) params.set("season", String(season));
  const qs = params.toString();
  return apiCall(`/api/admin/playoff-series-resolutions${qs ? `?${qs}` : ""}`);
}

export function upsertAdminPlayoffSeriesResolution(payload) {
  return apiCall("/api/admin/playoff-series-resolutions", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function deleteAdminPlayoffSeriesResolution(season, stageType, stageGroup) {
  return apiCall(
    `/api/admin/playoff-series-resolutions/${encodeURIComponent(String(season))}/${encodeURIComponent(stageType)}/${encodeURIComponent(stageGroup)}`,
    { method: "DELETE" }
  );
}
